var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Section',{staticClass:"banner",attrs:{"width":"sm"}},[_c('HeaderBanner',{attrs:{"header":_vm.$prismic.asText(_vm.slice.primary.sb_h1),"teaser":_vm.slice.primary.sb_teaser,"align":"center"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }